export default __webpack_public_path__ + "assets/images/d4533d21afa46fa020b8b6a65e2b2010.svg";